import { Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import ActionsContainer from '../actions-container/actions-container';
import { styles } from './text-input-styles';
import { TextInput as TextArea } from '@ncr-retail/base-retail-components';
import { IBRMInputDataRequiredInput } from 'src/common/api/brm/brm-utils';
import { useTranslation } from 'react-i18next';
import { MessageModal } from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { IMessageModal, MessageModalSizeEnum } from 'src/common/interfaces/dtos/IMessageModal';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';

const TextInput: React.FC<ITextInputProps> = (props: ITextInputProps): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();
  const { caption, message, onAccept, onCancel, fullScreen } = props;
  const [textInput, setTextInput] = useState<string>('');
  const [canApprove, setCanApprove] = useState<boolean>(false);
  const handleOnChange = (event): void => {
    setTextInput(event.target.value);
    setCanApprove(true);
  };

  const onSubmit = (): void => {
    if (canApprove) {
      onAccept({
        fieldName: props.inputName,
        value: textInput,
      });
    }
  };

  const subBarText = t('TextInputModalSubBarText');
  const dialogProps: IMessageModal = {
    dialogTestIdPrefix: 'input-text-dialog',
    size: MessageModalSizeEnum.FullScreen,
    type: EmeraldDialogTypes.InfoDecision,
    message: caption,
    subMessage: message,
    onAccept: onSubmit,
    onCancel: onCancel,
    fullScreen: fullScreen,
    dialogContentComponent: (
      <Grid container direction='column' className={classes.textContainer}>
        <Grid item>
          <TextArea
            autoFocus
            inputProps={{
              'data-testid': 'user-input',
              className: `global-keyboard`,
            }}
            label={props.inputLabel}
            className={classes.inputTextArea}
            onChange={handleOnChange}
            data-testid='input-text-brm-text-area'
          />
        </Grid>
        <Grid item className={classes.subBarText}>
          <Typography variant={'body2'}>{subBarText}</Typography>
        </Grid>
      </Grid>
    ),
    buttonComponent: (
      <Grid item container className={classes.bottomContainer}>
        <Grid item className={classes.buttonContainer}>
          <ActionsContainer
            close={onCancel}
            submit={onSubmit}
            canSubmit={canApprove}
            submitText={t('Ok')}
          />
        </Grid>
      </Grid>
    ),
  };

  return <MessageModal {...dialogProps} />;
};

export interface ITextInputProps {
  caption: string;
  message: string;
  onCancel: () => void;
  onAccept: (inputData: IBRMInputDataRequiredInput) => void;
  inputName?: string;
  inputLabel?: string;
  fullScreen?: boolean;
}

export default TextInput;
